import { render, staticRenderFns } from "./FlagshipGoalsStepLongGoal.vue?vue&type=template&id=2c01d1cf&"
import script from "./FlagshipGoalsStepLongGoal.vue?vue&type=script&lang=ts&"
export * from "./FlagshipGoalsStepLongGoal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VRow})
